import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { DEFAULT_SEO } from "../utils/seoDefaults";

const getCurrentPath = () => {
  if (typeof window === "undefined") {
    return "/";
  }
  return `${window.location.pathname || "/"}${window.location.search || ""}`;
};

const resolveAbsoluteUrl = (value, fallbackPath = "/") => {
  if (!value) {
    return new URL(fallbackPath, DEFAULT_SEO.siteUrl).toString();
  }
  if (/^https?:\/\//i.test(value)) {
    return value;
  }
  return new URL(value.startsWith("/") ? value : `/${value}`, DEFAULT_SEO.siteUrl).toString();
};

export default function SEO({ title, description, keywords, url }) {
  const resolvedTitle = title || DEFAULT_SEO.siteName;
  const resolvedDescription = description || DEFAULT_SEO.description;
  const resolvedUrl = resolveAbsoluteUrl(url, getCurrentPath());
  const resolvedImage = resolveAbsoluteUrl(DEFAULT_SEO.image, DEFAULT_SEO.image);

  return (
    <HelmetProvider>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{resolvedTitle}</title>
        <meta name="description" content={resolvedDescription} />
        {keywords && <meta name="keywords" content={keywords} />}
        <link rel="canonical" href={resolvedUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={resolvedTitle} />
        <meta property="og:description" content={resolvedDescription} />
        <meta property="og:url" content={resolvedUrl} />
        <meta property="og:image" content={resolvedImage} />
        <meta property="og:site_name" content={DEFAULT_SEO.siteName} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={resolvedTitle} />
        <meta name="twitter:description" content={resolvedDescription} />
        <meta name="twitter:image" content={resolvedImage} />
      </Helmet>
    </HelmetProvider>
  );
}
